import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";
import { AttendanceRosterResponseDto } from "../../shared/dtos/attendanceRecord/AttendanceRosterResponseDto";
import { AttendanceResponseDto } from "../../shared/dtos/attendanceRecord/AttendanceResponseDto";

export interface AttendanceRecordState {
  loadingRoster: boolean;
  loadingAttendanceRecords: boolean;
  loadingAttendanceBulk: boolean;
  loadingAttendanceDelete: boolean;
  errorLoadingRoster: string | null;
  errorLoadingAttendanceRecords: string | null;
  errorSavingBulk: string | null;
  errorDeletingAttendance: string | null;
  roster: AttendanceRosterResponseDto[];
  attendanceRecords: AttendanceResponseDto[];
  serverStatus: ServerStatusPayload | null;
}

const initialState: AttendanceRecordState = {
  loadingRoster: false,
  loadingAttendanceRecords: false,
  loadingAttendanceBulk: false,
  loadingAttendanceDelete: false,
  errorLoadingRoster: null,
  errorLoadingAttendanceRecords: null,
  errorSavingBulk: null,
  errorDeletingAttendance: null,
  roster: [],
  attendanceRecords: [],
  serverStatus: null,
};

export const attendanceRecordSlice = createSlice({
  name: "attendanceRecord",
  initialState,
  reducers: {
    setLoadingRoster(state) {
      state.loadingRoster = true;
      state.errorLoadingRoster = null;
    },
    setLoadingAttendanceRecords(state) {
      state.loadingAttendanceRecords = true;
      state.errorLoadingAttendanceRecords = null;
    },
    setLoadingAttendanceBulk(state) {
      state.loadingAttendanceBulk = true;
      state.errorSavingBulk = null;
    },
    setLoadingAttendanceDelete(state) {
      state.loadingAttendanceDelete = true;
      state.errorDeletingAttendance = null;
    },
    setErrorLoadingRoster(state, action: PayloadAction<string | null>) {
      state.loadingRoster = false;
      state.errorLoadingRoster = action.payload;
    },
    setErrorSavingBulk(state, action: PayloadAction<string | null>) {
      state.loadingAttendanceBulk = false;
      state.errorSavingBulk = action.payload;
    },
    setRoster(state, action: PayloadAction<AttendanceRosterResponseDto[]>) {
      state.loadingRoster = false;
      state.roster = action.payload;
    },
    setAttendanceRecords(
      state,
      action: PayloadAction<AttendanceResponseDto[]>,
    ) {
      state.loadingAttendanceRecords = false;
      state.attendanceRecords = action.payload;
    },
    saveBulkSuccess(state) {
      state.loadingAttendanceBulk = false;
      state.errorSavingBulk = null;
    },
    deleteAttendanceSuccess(state, action: PayloadAction<string>) {
      state.attendanceRecords = state.attendanceRecords.filter(
        (r) => r.id !== action.payload,
      );
      state.loadingAttendanceDelete = false;
    },
    setServerResponseStatus(
      state,
      action: PayloadAction<ServerStatusPayload | null>,
    ) {
      state.serverStatus = action.payload;
    },
    resetAttendanceState(state) {
      state.roster = [];
      state.serverStatus = null;
    },
  },
});

export const attendanceRecordActions = attendanceRecordSlice.actions;
export default attendanceRecordSlice.reducer;
